//libs
import { format } from "date-fns";
import {
  ArchiveBoxIcon,
  ArrowRightIcon,
  BuildingOffice2Icon,
  PaperClipIcon,
  PhoneIcon,
  UserIcon,
} from "@heroicons/react/20/solid";
//components
import TenderItemsTable from "./TenderItemsTable";
import TenderDocumentsTable from "./TenderDocumentsTable";
import Button from "../../../../../components/Button";
import QuotationItemsTable from "./QuotationItemsTable";
import { CloudArrowDownIcon } from "@heroicons/react/24/outline";

export default function GeneralInformation({ tender }) {
  const isTender = tender.opportunity_type === 1;

  const renderTenderInformation = () => (
    <>
      <div className="col-span-4 space-y-2 divide-y">
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Tender No</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.tender_no}
          </div>
        </div>
        <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Agency</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.department_name || "-"}
          </div>
        </div>
        <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Open Date</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.start_datetime
              ? format(new Date(tender.start_datetime), "dd MMM yyyy")
              : "N/A"}
          </div>
        </div>
        <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Type of Sourcing</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.type_of_sourcing || "-"}
          </div>
        </div>
        <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Evaluation Type</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.evaluation_type || "-"}
          </div>
        </div>
        <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Tender Category</div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.category_name && tender.sub_category_name ? (
              <div className="flex items-center gap-2">
                {tender.category_name}
                <ArrowRightIcon className="size-4" /> {tender.sub_category_name}
              </div>
            ) : (
              "N/A"
            )}
          </div>
        </div>
        {/* <div className="grid grid-cols-12 pt-2">
          <div className="col-span-3 text-sm">Offer Validity Duration</div>
          <div className="col-span-9 font-semibold text-sm">180 days</div>
        </div> */}
        {/* <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Offer Validity Duration: </div>
          <div className="col-span-9 font-semibold text-sm">180 days</div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Procurement Type: </div>
          <div className="col-span-9 font-semibold text-sm">Global Agency 23, 2023</div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Procurement Nature: </div>
          <div className="col-span-9 font-semibold text-sm">Global Agency 23, 2023</div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Procurement Method: </div>
          <div className="col-span-9 font-semibold text-sm">Global Agency 23, 2023</div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Payment Terms: </div>
          <div className="col-span-9 font-semibold text-sm">Global Agency 23, 2023</div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Procurement Category: </div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.tender_category_name}
          </div>
        </div>
        <div className="grid grid-cols-12">
          <div className="col-span-3 text-sm">Remark: </div>
          <div className="col-span-9 font-semibold text-sm">Global Agency 23, 2023</div>
        </div> */}
        <div className="grid grid-cols-12 text-wrap pt-2">
          <div className="col-span-3 text-sm">NDA Document </div>
          <div className="col-span-9 font-semibold text-sm">
            {tender.nda_document ? (
              <a
                href={tender.nda_document}
                target="_blank"
                className="text-blue-500 flex items-center gap-2"
                rel="noreferrer"
              >
                <PaperClipIcon className="size-4 " />
                Download NDA Document
              </a>
            ) : (
              "N/A"
            )}
          </div>
        </div>
      </div>
      <div className="col-span-2 space-y-4 mb-8">
        <div className="rounded-lg shadow-md ring-1 ring-gray-900/5">
          <dl className="flex flex-wrap">
            <div className="flex-auto pl-6 pt-6 pb-6">
              <dt className="text-sm font-normal leading-6 text-gray-900">
                Closing Date:
              </dt>
              <dd className="text-2xl font-medium leading-8 text-gray-900">
                {tender.end_datetime
                  ? format(new Date(tender.end_datetime), "dd MMM yyyy HH:mm a")
                  : "N/A"}
              </dd>
              {/* <dd className="text-3xl font-light leading-8 text-gray-900">
                {tender.end_datetime
                  ? format(new Date(tender.end_datetime), "HH:mm a")
                  : "N/A"}
              </dd> */}
            </div>
          </dl>
          {/* <div className="mt-4 px-6 pb-6">
            <p className="text-sm font-normal leading-4 text-gray-900">
              Mode of Submission:
            </p>
            <p className="font-bold">{tender.mode_of_submission}</p>
          </div> */}
        </div>
        <div className="rounded-lg divide-y shadow-md ring-1 ring-gray-900/5">
          <dl className="flex flex-wrap pb-4">
            <div className="flex-auto pl-6 pt-6">
              <dt className="text-sm font-normal leading-6 text-gray-900">
                Tender Briefing On Site:
              </dt>
              <dd className="text-lg font-medium leading-4 text-gray-900">
                {tender.briefing_date
                  ? format(
                      new Date(tender.briefing_date),
                      "dd MMM yyyy HH:mm a"
                    )
                  : "N/A"}
              </dd>
              <Button variant="outline" color="slate" className="mt-6 h-7">
                View Details
              </Button>
            </div>
          </dl>
          <div className="px-6 py-2.5">
            <p className="text-sm font-normal text-gray-900">
              Mode of Submission:
              <span className="font-bold leading-4 pl-4">
                {tender.mode_of_submission || "-"}
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
  const renderContact = () => (
    <div className="col-span-full">
      <h4 className="font-semibold flex gap-2 items-center leading-8 mb-4">
        <UserIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
        <span>Contact Details</span>
      </h4>
      <dl className="mt-4 pl-6 space-y-1 text-base text-gray-600">
        <div className="flex gap-x-4">
          <dt className="flex-none">
            <span className="sr-only">User</span>
            <UserIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
          </dt>
          <dd>
            <a
              href={`mailto:${tender.tender_contacts[0].email}`}
              className="hover:text-gray-900"
            >
              {tender.tender_contacts[0].contact_person}
            </a>
          </dd>
        </div>
        <div className="flex gap-x-4">
          <dt className="flex-none">
            <span className="sr-only">User</span>
            <ArchiveBoxIcon
              aria-hidden="true"
              className="h-7 w-6 text-gray-400"
            />
          </dt>
          <dd>
            <span className="hover:text-gray-900">
              {tender.tender_contacts[0].designation}
            </span>
          </dd>
        </div>
        <div className="flex gap-x-4">
          <dt className="flex-none">
            <span className="sr-only">Telephone</span>
            <PhoneIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
          </dt>
          <dd>
            <a
              href={`tel:${tender.tender_contacts[0].phone}`}
              className="hover:text-gray-900"
            >
              {tender.tender_contacts[0].phone}
            </a>
          </dd>
        </div>
        <div className="flex gap-x-4">
          <dt className="flex-none">
            <span className="sr-only">Address</span>
            <BuildingOffice2Icon
              aria-hidden="true"
              className="h-7 w-6 text-gray-400"
            />
          </dt>
          <dd>
            <span
              dangerouslySetInnerHTML={{
                __html: tender.tender_contacts[0].address,
              }}
            ></span>
          </dd>
        </div>
      </dl>
    </div>
  );

  return (
    <div className="pt-2 grid grid-cols-6 gap-8 rounded-md">
      <>{renderTenderInformation()}</>

      {tender.internal_details && (
        <div className="col-span-full py-8">
          <h4 className="font-semibold leading-8 mb-2">
            Additional Information
          </h4>
          <div
            dangerouslySetInnerHTML={{ __html: tender.internal_details }}
          ></div>
        </div>
      )}

      <div className="col-span-full">
        <TenderDocumentsTable
          documents={tender.documents || []}
          // actionButton={
          //   <Button
          //     variant="outline"
          //     color="slate"
          //     className="h-8 flex items-center gap-2 text-xs text-gray-600 hover:text-gray-900"
          //   >
          //     <CloudArrowDownIcon className="size-5" />
          //     Download all
          //   </Button>
          // }
        />
      </div>

      <div className="col-span-full py-4">
        {isTender ? (
          <TenderItemsTable items={tender.tender_items} />
        ) : (
          <QuotationItemsTable items={tender.tender_items} />
        )}
      </div>
      {tender.tender_contacts.length > 0 && <>{renderContact()}</>}
    </div>
  );
}
